<ng-select
  [items]="searchResults$ | async"
  [addTag]="false"
  [hideSelected]="true"
  [loading]="searchLoading"
  [typeahead]="searchInput$"
  [multiple]="true"
  appendTo="body"
  bindLabel="id"
  [disabled]="disabled || readonly"
  [ngModel]="value"
  (change)="onChange($event)"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <!-- <vdr-facet-value-chip
     
      [facetValue]="item"
      [removable]="!readonly"
      (remove)="clear(item)"
    ></vdr-facet-value-chip> -->

    <!-- <div class="button-ghost" *ngIf="item; else facetNotFound">
      <span class="mx-1">{{ item.name }}</span>
    </div> -->

    <vdr-chip
      [icon]="'times'"
      [colorFrom]="item.name"
      (iconClick)="clear(item)"
    >
      <span>{{ item.name }}</span>
    </vdr-chip>

    <ng-template #facetNotFound>
      <vdr-chip colorType="error" icon="times" (iconClick)="clear(item)">{{
        "catalog.facet-value-not-available" | translate : { id: item.id }
      }}</vdr-chip>
    </ng-template>
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    <!-- <vdr-facet-value-chip
      [facetValue]="item"
      [removable]="false"
    ></vdr-facet-value-chip> -->

    <vdr-chip [colorFrom]="item.name">
      <span>{{ item.name }}</span>
    </vdr-chip>
  </ng-template>
</ng-select>
